import React, { memo } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./File.module.scss";
import { CSV } from "../../../../assets/images/icons/CSV";
import { PDF } from "../../../../assets/images/icons/PDF";
import { XLS } from "../../../../assets/images/icons/XLS";
import Icon from "../../../Icon";

Icon.add(CSV);
Icon.add(PDF);
Icon.add(XLS);

const File = ({ type, handleExportFile, printAll, printAllText, className }) => {
  return (
    <div
      className={cn(styles.icons, className)}
      onClick={() => handleExportFile(type, printAll)}
      role="button"
      tabIndex="0"
    >
      <span className={styles.type}>{type}</span>
      <Icon icon={type} />
      {printAll && <span className={styles.printAll}>{printAllText}</span>}
    </div>
  );
};

File.propTypes = {
  type: PropTypes.string.isRequired,
  printAll: PropTypes.bool,
  printAllText: PropTypes.string,
  className: PropTypes.string,
  handleExportFile: PropTypes.func.isRequired
};

File.defaultProps = {
  printAll: false,
  printAllText: "PRINT ALL",
  className: ""
};

export default memo(File);
